import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationPanel = ({ notifications, onMarkAsRead, onViewAll }) => {
  const getNotificationIcon = (type) => {
    switch (type) {
      case 'task_assigned':
        return 'UserPlus';
      case 'deadline_reminder':
        return 'Clock';
      case 'status_update':
        return 'CheckCircle';
      case 'announcement':
        return 'Megaphone';
      case 'approval_required':
        return 'AlertCircle';
      default:
        return 'Bell';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'task_assigned':
        return 'text-primary';
      case 'deadline_reminder':
        return 'text-warning';
      case 'status_update':
        return 'text-success';
      case 'announcement':
        return 'text-accent';
      case 'approval_required':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInMinutes = Math.floor((now - time) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className="bg-card border border-border rounded-lg card-shadow">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Recent Notifications</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="ExternalLink"
          onClick={onViewAll}
        >
          View All
        </Button>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {notifications?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Bell" size={32} className="mx-auto text-muted-foreground mb-2" />
            <p className="text-sm text-muted-foreground">No new notifications</p>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {notifications?.map((notification) => (
              <div
                key={notification?.id}
                className={`p-4 hover:bg-muted/50 transition-smooth ${
                  !notification?.read ? 'bg-primary/5' : ''
                }`}
              >
                <div className="flex items-start space-x-3">
                  <div className={`flex-shrink-0 ${getNotificationColor(notification?.type)}`}>
                    <Icon name={getNotificationIcon(notification?.type)} size={16} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground mb-1">
                      {notification?.title}
                    </p>
                    <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
                      {notification?.message}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-muted-foreground">
                        {formatTimeAgo(notification?.timestamp)}
                      </span>
                      {!notification?.read && (
                        <Button
                          variant="ghost"
                          size="xs"
                          onClick={() => onMarkAsRead(notification?.id)}
                        >
                          Mark as read
                        </Button>
                      )}
                    </div>
                  </div>
                  {!notification?.read && (
                    <div className="w-2 h-2 bg-primary rounded-full flex-shrink-0 mt-2" />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;